import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-5xl font-bold text-gray-900 mb-6">
          Ready to Boost Your Rankings?
        </h2>
        <p className="text-xl text-gray-600 mb-8">
          Join thousands of businesses optimizing their content with SEOPower
        </p>
        <Link
          to="/purchase"
          className="inline-flex items-center gap-2 px-8 py-4 bg-[#4f3af6] text-white rounded-full font-medium text-lg hover:bg-[#4f3af6]/90 transition-all whitespace-nowrap cursor-pointer"
        >
          Try SEOPower Today
          <i className="ri-arrow-right-line"></i>
        </Link>

      </div>
    </section>
  );
};

export default CTASection;
